// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskPermitForm_root__0fiU4 .TaskPermitForm_loading__crJDB {
  display: flex;
  height: 160px;
  align-items: center;
  justify-content: center;
}
.TaskPermitForm_root__0fiU4 .TaskPermitForm_details__RQtZt {
  font-size: 15px;
  letter-spacing: 0.1px;
  color: #575757;
  line-height: 1.6;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/TaskPermitForm/TaskPermitForm.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,eAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAAJ","sourcesContent":[".root {\r\n  .loading {\r\n    display: flex;\r\n    height: 160px;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .details {\r\n    font-size: 15px;\r\n    letter-spacing: 0.1px;\r\n    color: #575757;\r\n    line-height: 1.6;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TaskPermitForm_root__0fiU4`,
	"loading": `TaskPermitForm_loading__crJDB`,
	"details": `TaskPermitForm_details__RQtZt`
};
export default ___CSS_LOADER_EXPORT___;
